import DropDownRadioSelect from '@gp/components/DropDownRadioSelect';
import DropDownSelect from '@gp/components/DropDownSelect';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import GeneralModal from '@gp/components/GeneralModal';
import OperationBtns from '@gp/components/OperationBtns';
import { FIELD_COMMON_ERR_MSG } from '@gp/constants/const';
import '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit/components/ArchiveEditForm/index.scss';
import {
  ADD_EMP_PROJECT_CORE_STAKEHOLDERS,
  ADD_TYPE_PROJECT_CORE_STAKEHOLDERS,
  DELETE_EMP_PROJECT_CORE_STAKEHOLDERS,
  DELETE_TYPE_PROJECT_CORE_STAKEHOLDERS,
  SELECT_TYPE_PROJECT_CORE_STAKEHOLDERS,
  UPDATE_EMP_PROJECT_CORE_STAKEHOLDERS,
} from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit/consts';
import { reportOperationLog } from '@gp/services/global';
import { getEditableStaffSearchList } from '@gp/services/projectDetail';
import { getTencentAvatarSrc, isLegalHttpUrl } from '@gp/utils/common';
import { useDebounceFn, useMemoizedFn } from 'ahooks';
import classnames from 'classnames';
import React, { memo, useCallback, useRef, useState } from 'react';
import { ActionCreators } from 'redux-undo';
import { Form, FormItemProps, Input, notification } from 'tea-component';

const { TextArea } = Input;

const ArchiveEditForm: React.FC<any> = (props) => {
  const {
    showError,
    validation,
    organization,
    ownerList,
    stakeholdersDataDispatch,
    projectDetailData,
  } = props;

  const notificationDestroy = useRef<any>(null);

  const currentTypeIndex = useRef(-1);

  const [generalModalVisible, setGenrealModalVisible] = useState(false);

  const [IEGGPositionList, setAllPositionList] = useState<string[]>([]);

  const getTypes = useCallback(
    (type: string) => {
      const selectedTypes = ownerList?.map((item: any) => item?.project_owner || '') || [];
      return [
        {
          value: 'development',
          text: 'Development',
          disabled: type !== 'development' && selectedTypes?.includes('development'),
        },
        {
          value: 'publishing',
          text: 'Publishing',
          disabled: type !== 'publishing' && selectedTypes?.includes('publishing'),
        },
        {
          value: 'finance',
          text: 'Finance',
          disabled: type !== 'finance' && selectedTypes?.includes('finance'),
        },
      ];
    },
    [ownerList],
  );

  const getPositionOptions = useMemoizedFn((data: any, selectList: string[]) => {
    return [
      {
        value: 'business_owner',
        text: 'Business Owner',
        disabled: data?.position !== 'business_owner' && selectList?.includes('business_owner'),
      },
      {
        value: 'pteam_contact',
        text: 'P-team Contact',
        disabled: data?.position !== 'pteam_contact' && selectList?.includes('pteam_contact'),
      },
      {
        value: 'finance_contact',
        text: 'Finance Contact',
        disabled: data?.position !== 'finance_contact' && selectList?.includes('finance_contact'),
      },
    ];
  });

  const handleAddType = useCallback(() => {
    if (stakeholdersDataDispatch instanceof Function) {
      stakeholdersDataDispatch({
        type: ADD_TYPE_PROJECT_CORE_STAKEHOLDERS,
        payload: {
          organization,
        },
      });
    }
  }, [organization, stakeholdersDataDispatch]);

  const handleCloseGeneralModal = useCallback(() => {
    currentTypeIndex.current = -1;
    setGenrealModalVisible(false);
  }, []);

  const handleDeleteTypePre = useCallback((index: number) => {
    currentTypeIndex.current = index;
    setGenrealModalVisible(true);
  }, []);

  const handleDeleteType = useCallback(() => {
    if (stakeholdersDataDispatch instanceof Function) {
      stakeholdersDataDispatch({
        type: DELETE_TYPE_PROJECT_CORE_STAKEHOLDERS,
        payload: {
          organization,
          index: currentTypeIndex.current,
        },
      });
    }
    handleCloseGeneralModal();
  }, [organization, stakeholdersDataDispatch]);

  const handleTypeChange = useCallback(
    (v: string | undefined, i: number) => {
      // 不选或点击清空按钮时返回undefinds
      if (stakeholdersDataDispatch instanceof Function) {
        stakeholdersDataDispatch({
          type: SELECT_TYPE_PROJECT_CORE_STAKEHOLDERS,
          payload: {
            organization,
            index: i,
            type: v,
          },
        });
      }
    },
    [organization, stakeholdersDataDispatch],
  );

  const handleAddEmp = useCallback(
    (i: number) => {
      if (stakeholdersDataDispatch instanceof Function) {
        stakeholdersDataDispatch({
          type: ADD_EMP_PROJECT_CORE_STAKEHOLDERS,
          payload: {
            organization,
            index: i,
          },
        });
      }
    },
    [organization, stakeholdersDataDispatch],
  );

  const { run: handleReverseDeleteEmpOperation } = useDebounceFn(
    () => {
      stakeholdersDataDispatch(ActionCreators.undo());
      const destroy = notificationDestroy.current;
      if (destroy instanceof Function) {
        destroy();
      }
    },
    { wait: 300 },
  );

  const handleDeleteEmp = useCallback(
    (i: number, empI: number) => {
      if (stakeholdersDataDispatch instanceof Function) {
        stakeholdersDataDispatch({
          type: DELETE_EMP_PROJECT_CORE_STAKEHOLDERS,
          payload: {
            organization,
            index: i,
            empIndex: empI,
          },
        });

        const { destroy } = notification.success({
          unique: true,
          style: {
            fontSize: 14,
          },
          description: (
            <span>
              Successfully delete!{' '}
              <span
                style={{ color: '#326ff0', cursor: 'pointer' }}
                onClick={handleReverseDeleteEmpOperation}
              >
                Undo operation
              </span>
            </span>
          ),
        });
        notificationDestroy.current = destroy;
      }
    },
    [organization, stakeholdersDataDispatch],
  );

  /* useEffect(() => {
    if (Array.isArray(ownerList) && ownerList?.length && (organization === 'iegg')) {
      const newAllPositionList = [];
      for (let index = 0; index < ownerList?.length; index ++) {
        const item = ownerList?.[index];
        const list = item?.list;
        if (Array.isArray(list) && list?.length) {
          for (let i = 0; i < list?.length; i ++) {
            const t = list?.[i];
            if (t?.position) {
              newAllPositionList.push(t?.position);
            }
          }
        }
      }
      setAllPositionList(newAllPositionList);
    }
  }, [ownerList]); */

  const handleUpdateEmp = useCallback(
    (i: number, empI: number, emp: any) => {
      if (stakeholdersDataDispatch instanceof Function) {
        stakeholdersDataDispatch({
          type: UPDATE_EMP_PROJECT_CORE_STAKEHOLDERS,
          payload: {
            organization,
            index: i,
            empIndex: empI,
            emp,
          },
        });
      }
    },
    [organization, stakeholdersDataDispatch],
  );

  return (
    <div className="archive-edit-form-comp font14">
      <Form className="archive-edit-form">
        <Form.Item label="Project owner">
          {ownerList?.map((owner: any, index: number) => (
            <div key={index} className="archive-edit-form-section">
              <div
                className={classnames('archive-edit-form-type-bar', {
                  'is-error': showError && !validation?.isValid && !owner?.project_owner,
                })}
              >
                <DropDownRadioSelect
                  key={owner?.key}
                  className="archive-edit-type-selector"
                  style={{
                    width: 260,
                    height: 34,
                  }}
                  isFont14
                  allOpt={{
                    options: getTypes(owner?.project_owner),
                    defaultValue: owner?.project_owner || '',
                    placeholder: 'Please choose Classification',
                    isDisabledSelected: true,
                    isDisabledHide: true,
                  }}
                  onChange={(v: string | undefined) => {
                    handleTypeChange(v, index);
                  }}
                />
                <OperationBtns
                  style={{ marginLeft: 20 }}
                  isShowDelete={ownerList?.length > 1}
                  isShowAdd={ownerList?.length < 3 && index === ownerList?.length - 1}
                  onDelete={() => {
                    handleDeleteTypePre(index);
                  }}
                  onAdd={handleAddType}
                />
              </div>
              {showError && !validation?.isValid && !owner?.project_owner && (
                <div className="archive-edit-form-control-error-msg">{FIELD_COMMON_ERR_MSG}</div>
              )}
              {owner?.project_owner && (
                <ul className="archive-edit-form-owner-list">
                  {owner?.list?.map((emp: any, empIndex: number) => {
                    return (
                      <UserMsgItem
                        key={empIndex}
                        index={index}
                        empIndex={empIndex}
                        showError={showError}
                        validation={validation}
                        organization={organization}
                        emp={emp}
                        owner={owner}
                        IEGGPositionList={IEGGPositionList}
                        handleUpdateEmp={handleUpdateEmp}
                        getPositionOptions={getPositionOptions}
                        handleDeleteEmp={handleDeleteEmp}
                        handleAddEmp={handleAddEmp}
                        projectName={projectDetailData?.name}
                      />
                    );
                  })}
                </ul>
              )}
            </div>
          ))}
        </Form.Item>
      </Form>
      <GeneralModal
        title="Do you want to delete it?"
        content="After deletion, the edited information will not be saved"
        visible={generalModalVisible}
        onConfirm={handleDeleteType}
        onClose={handleCloseGeneralModal}
      />
    </div>
  );
};

const UserMsgItem = (props: any) => {
  const {
    index,
    empIndex,
    showError,
    validation,
    organization,
    emp,
    owner,
    IEGGPositionList,
    handleUpdateEmp,
    getPositionOptions,
    handleDeleteEmp,
    handleAddEmp,
    projectName,
  } = props;

  const [linkMsg, setLinkMsg] = useState<{ [keyName: string]: string }>({
    link: '',
    status: 'success',
    message: '',
  });

  return (
    <li key={empIndex} className="archive-edit-form-owner-item">
      <div className="archive-edit-form-summary">
        <Form
          layout="fixed"
          fixedLabelWidth={organization === 'studio' ? 127 : 54}
          className={`archive-edit-summary-form archive-edit-summary-form-${organization}`}
        >
          <Form.Item
            label="Name"
            status={
              showError && !validation?.isValid && !emp?.user_id && !emp?.name ? 'error' : 'success'
            }
            message={
              showError && !validation?.isValid && !emp?.user_id && !emp?.name
                ? FIELD_COMMON_ERR_MSG
                : ''
            }
          >
            {organization === 'iegg' && (
              <DropDownSelect
                className="archive-edit-emp-selector"
                allOpt={{
                  placeholder: 'Please choose Personnel',
                  searchPlaceholder: 'Search',
                  clearable: false,
                  searchable: true,
                  staging: false,
                  isCustomButtonCtx: true,
                  defaultValue: emp?.user_id || '',
                  options: emp?.options || [],
                  services: getEditableStaffSearchList,
                  paramFormat: {
                    // 搜索时接口参数格式
                    keys: ['sub_name'],
                    params: {
                      cond_name: 'user',
                      sub_name: '',
                      studio_id: '',
                    },
                  },
                }}
                getButtonCtx={
                  !emp?.name
                    ? undefined
                    : () => {
                        return (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {
                              <GeneralImageNew
                                domain="user"
                                width={20}
                                height={20}
                                style={{
                                  marginRight: 4,
                                  backgroundColor: '#fff',
                                  borderRadius: 4,
                                }}
                                src={getTencentAvatarSrc(emp?.name, 150)}
                              />
                            }
                            <span>{emp?.name || ''}</span>
                          </div>
                        );
                      }
                }
                onChange={(data: any) => {
                  const emp = {
                    name: data?.options?.[0]?.text || '',
                    user_id: data?.value || '',
                  };
                  handleUpdateEmp(index, empIndex, emp);
                }}
                onSuccessSearch={(v: any, keyword: string) => {
                  keyword &&
                    reportOperationLog(
                      {
                        query: keyword,
                        extInfo: '500501', // 当前页面id
                        clickId: '',
                        uidType: 'game_code',
                        uid: projectName,
                      },
                      'search',
                    );
                  // 搜索结果，这里组织新的配置项
                  const newOptions = v?.map((t: any) => {
                    return {
                      value: t?.user_id,
                      text: t?.user_name,
                    };
                  });
                  const emp = {
                    options: newOptions,
                  };
                  handleUpdateEmp(index, empIndex, emp);
                }}
              />
            )}
            {organization === 'studio' && (
              <Input
                placeholder="Please enter Personnel"
                value={emp?.name}
                onChange={(v: string) => {
                  const emp = {
                    name: v || '',
                    user_id: '',
                  };
                  handleUpdateEmp(index, empIndex, emp);
                }}
              />
            )}
          </Form.Item>
          <Form.Item
            label="Position"
            status={showError && !validation?.isValid && !emp?.position ? 'error' : 'success'}
            message={
              showError && !validation?.isValid && !emp?.position ? FIELD_COMMON_ERR_MSG : ''
            }
          >
            <DropDownRadioSelect
              style={{
                // width: 240,
                height: 34,
              }}
              isFont14
              allOpt={{
                // value值对应的是后端字段名
                options: getPositionOptions(emp, IEGGPositionList),
                defaultValue: emp?.position,
                placeholder: 'Please choose Position',
                clearable: true,
                isDisabledSelected: true,
                isDisabledHide: true,
                custombuttonable: true,
                customInputPlaceholder: 'Please input Position name',
                customRepeatCheck: true,
                customInputIsRepeatBubbleContent: 'Repeat option, please check!',
              }}
              onChange={(v: string | undefined, message: { isRepeat: boolean }) => {
                if (message?.isRepeat) {
                  // 有重复时
                  return;
                }
                const emp = {
                  position: v,
                };
                handleUpdateEmp(index, empIndex, emp);
              }}
              previousList={IEGGPositionList}
            />
          </Form.Item>
          {organization === 'studio' && (
            <Form.Item
              label="LinkedIn (optional)"
              status={linkMsg?.status as FormItemProps['status']}
              message={linkMsg?.message}
            >
              <Input
                placeholder="Please enter a Link of LinkedIn"
                value={emp?.link}
                onChange={(v: string) => {
                  const isAllow = isLegalHttpUrl(v) || !v;
                  if (isAllow) {
                    setLinkMsg({ link: v, status: 'success', message: '' });
                  } else {
                    setLinkMsg({
                      link: v,
                      status: 'error',
                      message: 'Please check that information is correct.',
                    });
                  }
                  const emp = {
                    link: v,
                    linkStatus: isAllow ? 'success' : 'error', // error时禁用顶部的Confrim按钮
                  };
                  handleUpdateEmp(index, empIndex, emp);
                }}
              />
            </Form.Item>
          )}
        </Form>
      </div>
    </li>
  );
};

export default memo(ArchiveEditForm);
